import {
  AutocompleteSearchAction,
  AutocompleteSearchActionType,
  IAutocompleteSearchLoadedPayload,
  ISetAutocompleteSearchErroredPayload
} from "../Actions/AutocompleteSearchActions";
import { AutocompleteItem } from "../Models/AutocompleteItem";

export interface AutocompleteSearchState {
  items: AutocompleteItem[];
  isLoaded: boolean;
  isLoading: boolean;
  isErrored: boolean;
  errorMessage: string;
  errorCode?: number;
}

const initialAutocompleteSearchState: AutocompleteSearchState = {
  items: [],
  isLoaded: false,
  isLoading: false,
  isErrored: false,
  errorMessage: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const autocompleteSearchReducer = (
  autocompleteSearchState: AutocompleteSearchState = initialAutocompleteSearchState,
  action: AutocompleteSearchAction
) => {
  switch (action.type) {
    case AutocompleteSearchActionType.AUTOCOMPLETE_SEARCH_LOADED: {
      const payload = <IAutocompleteSearchLoadedPayload>action.payload;

      const { loadedItems } = payload;

      return updateObject(autocompleteSearchState, {
        items: loadedItems,
        isLoaded: true,
        isLoading: false,
        isErrored: false
      });
    }
    case AutocompleteSearchActionType.AUTOCOMPLETE_SEARCH_UNLOAD: {
      return updateObject(autocompleteSearchState, {
        items: [],
        isLoaded: false,
        isLoading: false,
        isErrored: false
      });
    }
    case AutocompleteSearchActionType.AUTOCOMPLETE_SEARCH_SET_LOADING: {
      return updateObject(autocompleteSearchState, {
        ...autocompleteSearchState,
        isLoaded: false,
        isLoading: true,
        isErrored: false
      });
    }
    case AutocompleteSearchActionType.AUTOCOMPLETE_SEARCH_SET_ERRORED: {
      const payload = <ISetAutocompleteSearchErroredPayload>action.payload;

      return updateObject(autocompleteSearchState, {
        isErrored: true,
        errorMessage: payload.errorDescription,
        errorCode: payload.errorCode
      });
    }
    default:
      return autocompleteSearchState;
  }
};

export default autocompleteSearchReducer;
